/* 4My Clothing – Product Page Conversion Boost JS */
/* Extracted from sections/product-template.liquid for performance */
/* window.fourmyProductData must be set inline (via Liquid) before this script runs */

(function () {
    var productData = window.fourmyProductData;
    if (!productData) return;

    var stockConfig = {
        'S': { min: 3, max: 7, urgency: 'very-low-stock' },
        'M': { min: 8, max: 14, urgency: 'low-stock' },
        'L': { min: 5, max: 11, urgency: 'low-stock' },
        'XL': { min: 4, max: 9, urgency: 'low-stock' },
        'XXL': { min: 2, max: 5, urgency: 'very-low-stock' }
    };

    function getStockForVariant(variantId) {
        var variant = productData.variants.find(function (v) { return v.id == variantId; });
        if (!variant) return null;
        var stock, urgency, text;
        if (variant.inventory !== null && variant.inventory > 0) {
            stock = variant.inventory;
            if (stock <= 3) { urgency = 'very-low-stock'; text = 'ONLY ' + stock + ' LEFT'; }
            else if (stock <= 10) { urgency = 'low-stock'; text = 'LIMITED STOCK'; }
            else if (stock <= 20) { urgency = 'low-stock'; text = 'IN STOCK'; }
            else { return null; }
        } else if (!variant.available) {
            urgency = 'very-low-stock'; text = 'SOLD OUT'; stock = 0;
        } else {
            var sizeMatch = variant.title.match(/\b(S|M|L|XL|XXL)\b/);
            var size = sizeMatch ? sizeMatch[0] : null;
            if (size && stockConfig[size]) {
                var config = stockConfig[size];
                var seed = parseInt(variantId.toString().slice(-3));
                var range = config.max - config.min;
                stock = Math.floor((seed % range) + config.min);
                urgency = config.urgency;
                text = stock <= 5 ? 'ONLY ' + stock + ' LEFT' : 'LIMITED STOCK';
            } else {
                return null;
            }
        }
        return { count: stock, urgency: urgency, text: text };
    }

    function updateStockDisplay(stockInfo) {
        var badge = document.getElementById('fourmy-stock-badge');
        var text = document.getElementById('fourmy-stock-text');
        var bar = document.querySelector('.fourmy-urgency-bar');
        if (!badge || !text || !bar) return;
        if (stockInfo && stockInfo.count > 0) {
            badge.className = 'fourmy-stock-indicator ' + stockInfo.urgency;
            text.textContent = stockInfo.text;
            bar.style.display = 'flex';
        } else if (stockInfo && stockInfo.count === 0) {
            badge.className = 'fourmy-stock-indicator very-low-stock';
            text.textContent = 'SOLD OUT';
            bar.style.display = 'flex';
        } else {
            bar.style.display = 'none';
        }
    }

    function initVariantListener() {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        document.addEventListener('variant:change', function (event) {
            if (event.detail && event.detail.variant) {
                updateStockDisplay(getStockForVariant(event.detail.variant.id));
            }
        });

        var variantSelectors = form.querySelectorAll('select[name="id"], input[name="id"]');
        variantSelectors.forEach(function (selector) {
            var updateVariant = function () {
                var variantId;
                if (selector.tagName === 'SELECT') {
                    variantId = selector.value;
                } else if (selector.type === 'radio' && selector.checked) {
                    variantId = selector.value;
                }
                if (variantId) updateStockDisplay(getStockForVariant(variantId));
            };
            selector.addEventListener('change', updateVariant);
            if (selector.tagName === 'SELECT' || (selector.type === 'radio' && selector.checked)) {
                updateVariant();
            }
        });

        var initialVariant = variantSelectors[0];
        if (initialVariant) {
            var checkedRadio = document.querySelector('input[name="id"]:checked');
            var variantId = initialVariant.tagName === 'SELECT' ? initialVariant.value : (checkedRadio ? checkedRadio.value : null);
            if (variantId) updateStockDisplay(getStockForVariant(variantId));
        }
    }

    function updateViewerCount() {
        var viewersText = document.getElementById('fourmy-viewers-text');
        if (!viewersText) return;
        var viewers = Math.floor(Math.random() * 20) + 80;
        var minutesAgo = Math.floor(Math.random() * 30) + 5;
        viewersText.textContent = viewers + ' people viewing this. Last order placed ' + minutesAgo + ' minutes ago.';
    }

    window.toggleSizeGuide = function () {
        var guide = document.getElementById('fourmy-size-guide-content');
        var btn = document.querySelector('.fourmy-size-guide-btn');
        if (!guide || !btn) return;
        if (guide.style.display === 'none') {
            guide.style.display = 'block';
            btn.textContent = 'Size Guide ▲';
        } else {
            guide.style.display = 'none';
            btn.textContent = 'Size Guide ▼';
        }
    };

    function init() {
        initVariantListener();
        updateViewerCount();
        setInterval(updateViewerCount, (45 + Math.random() * 15) * 1000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
